import {inject, Injectable} from "@angular/core";
import {CanActivate, CanActivateFn, CanMatchFn, Router} from "@angular/router";
import {AuthService} from "./Auth.service";

export const HomeGuard: CanActivateFn | CanMatchFn = (route: { data: { [x: string]: any; }; }) => {
  const router = inject(Router);
  const auth = inject(AuthService);

    return auth.isAuthenticated()
      ? true
      : router.parseUrl('/login');

}
